import React from "react";
import classnames from "classnames";
import { mergeProps } from "../../utils/mergeProps";
import { withNativeProps } from "../../utils/with-native-props";
import { isNodeWithContent } from "../../utils/is-node-with-content";
var defaultProps = {
  percent: 0,
  rounded: true,
  text: false
};
var classPrefix = "tc-progress-bar";
var ProgressBar = function ProgressBar(p) {
  var props = mergeProps(defaultProps, p);
  var percent = props.percent,
    rounded = props.rounded,
    text = props.text,
    className = props.className,
    style = props.style;
  var fillStyle = {
    width: "".concat(percent, "%")
  };
  var textElement = function () {
    if (text === true) {
      return "".concat(percent, "%");
    }
    if (typeof text === "function") {
      return text(percent);
    }
    return text;
  }();
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: classnames(classPrefix, rounded && "".concat(classPrefix, "-rounded"), className),
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-line")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-fill"),
    style: fillStyle
  })), isNodeWithContent(textElement) && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-text")
  }, textElement)));
};
ProgressBar.defaultProps = defaultProps;
export default ProgressBar;